exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* \n*  Created by SGiri 07/12/2018\n*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/cognos/cognos-search/cognos-search.component.css
// module id = ../../../../../src/app/cognos/cognos-search/cognos-search.component.css
// module chunks = main